<template>
  <div class="content-page">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('lian-xi-wo-men') }} </div>


    <div class="contact-content" v-html="content"></div>

  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png'),
      content: `
        <div class="contact-section">
          <h2>Contact Us</h2>
          
          <div class="contact-item">
            <p>If you have any questions, suggestions, or need assistance, please feel free to contact us via email:</p>
            <p class="email-address">info@${window.location.hostname}</p>
            <p>We will respond to your inquiry as soon as possible.</p>
          </div>
        </div>
      `
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>
<style scoped>
.contact-content {
  padding: 20px;
  color: #333;
  line-height: 1.6;
}

.contact-section {
  max-width: 800px;
  margin: 20px auto;
  text-align: center;
}

.contact-section h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #0d47a1;
}

.contact-item {
  margin-bottom: 30px;
}

.contact-item p {
  margin-bottom: 15px;
}

.email-address {
  font-size: 22px;
  font-weight: 600;
  color: #0d47a1;
  margin: 25px 0;
}
</style>